import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 全局组测
import './utils/global.js';
import Cookies from 'js-cookie'
Vue.prototype.$cookies = Cookies;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
